import React from "react"

import ExploreTherapiesSection from "../HomePageV2Archived/components/ExploreTherapiesSection"
import Footer from "../HomePageV2Archived/components/Footer"
import Header from "../HomePageV2Archived/components/Header"
import ProCTASection from "../HomePageV2Archived/components/ProCTASection"
import ReviewsSection from "../HomePageV2Archived/components/ReviewsSection"

import FeaturedProsLandingSection from "./components/FeaturedProsLandingSection"
import HeroLandingSection from "./components/HeroLandingSection"
import VirtualProsLandingSection from "./components/VirtualProsLandingSection"

const HomePageV2Desktop = ({
  reviews,
  therapyCategories,
  featuredPractitioners,
  virtualPractitioners,
  currentLocation,
  isLoadingPractitioners,
  initialLocation
}) => (
  // eslint-disable-next-line tailwindcss/no-custom-classname
  <div className="homepage-v2">
    <div
      className="relative pb-16"
      style={{
        backgroundImage:
          "linear-gradient(103.65deg, rgb(var(--color-gradient-start)) 18.973%, rgb(var(--color-gradient-end)) 97.511%)"
      }}>
      <div className="relative z-10">
        <Header isMobile={false} />
        <HeroLandingSection isMobile={false} initialLocation={initialLocation} />
      </div>
    </div>
    <FeaturedProsLandingSection
      practitioners={featuredPractitioners}
      isMobile={false}
      location={currentLocation}
      isLoading={isLoadingPractitioners}
    />
    <VirtualProsLandingSection practitioners={virtualPractitioners} isMobile={false} isLoading={false} />
    <ReviewsSection reviews={reviews} isMobile={false} />
    <div
      className="relative"
      style={{
        backgroundImage:
          "linear-gradient(96.01577665233063deg, rgb(var(--color-gradient-start)) 37.905%, rgb(var(--color-gradient-end)) 97.929%)"
      }}>
      <ProCTASection isMobile={false} />
    </div>
    <ExploreTherapiesSection therapyCategories={therapyCategories} isMobile={false} />
    <Footer isMobile={false} />
  </div>
)

export default HomePageV2Desktop
